export default "__VITE_ASSET__DQqVYuJz__"